import {Badge} from '@mantine/core';
import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {ComplianceStandardResponse} from 'src/api/ProactApiClient';
import {ComplianceStandardTypeEnum} from 'src/api/ProactApiClient';
import {getTypeColor, getTypeLabel} from '../../complianceStandardHelpers';

export const useComplianceStandardColumns = () => {
  const columns = useMemo<MRT_ColumnDef<ComplianceStandardResponse>[]>(
    () => [
      {
        accessorKey: 'titleNumberLabel',
        header: 'Title',
        size: 150,
      },
      {
        accessorKey: 'sectionLabel',
        header: 'Section',
        size: 400,
      },
      {
        accessorKey: 'type',
        header: 'Type',
        size: 100,
        filterVariant: 'select',
        mantineFilterSelectProps: {
          data: [
            {value: String(ComplianceStandardTypeEnum.EPA), label: 'EPA'},
            {value: String(ComplianceStandardTypeEnum.OSHA), label: 'OSHA'},
            {
              value: String(ComplianceStandardTypeEnum.Custom),
              label: 'Custom',
            },
          ],
        },
        Cell: ({cell}) => {
          const value = cell.getValue<ComplianceStandardTypeEnum>();
          return (
            <Badge size="sm" variant="light" color={getTypeColor(value)}>
              {getTypeLabel(value)}
            </Badge>
          );
        },
      },
      {
        id: 'issuedAt',
        accessorFn: row => (row.issuedAt ? new Date(row.issuedAt) : null),
        filterVariant: 'date',
        header: 'Issued Date',
        size: 150,
        Cell: ({cell}) => {
          const value = cell.getValue<Date | null>();
          return <>{value ? String(value).toShortDate() : ''}</>;
        },
      },
    ],
    []
  );

  return columns;
};
